import { OverseaProductInfo } from '../component/OverseaProductInfo';
import { OverseaProductInfoService } from '../service/OverseaProductInfoService';

export const OverseaProductInfoContainer = () => {
  const { product_info_map } = OverseaProductInfoService();

  if (!product_info_map) {
    return null;
  }

  return <OverseaProductInfo data={product_info_map} />;
};
